import React from 'react';

import { RouteProps, Navigate, Outlet } from 'react-router-dom';
import { login as loginUri } from 'routes/uris';

const ProtectedRouteComponent: React.FC<RouteProps> = (route) => {
    const isAuthenticated = !!window.localStorage.getItem('token');
    
    if (!isAuthenticated) {
        return (
            <Navigate
                to={loginUri}
            />
        );
    }

    return <Outlet />;
};

export default ProtectedRouteComponent;
